import React from 'react';
import { EmbeddableConfigContext } from '../config/EmbeddableContext';

const withEmbeddedContext = (WrappedComponent) => function withEmbeddedContexts(props) {
  return (
    <EmbeddableConfigContext.Consumer>
      {
      // eslint-disable-next-line react/jsx-props-no-spreading
      (embeddedContext) => (<WrappedComponent embeddedContext={embeddedContext} {...props} />)
    }
    </EmbeddableConfigContext.Consumer>
  );
};

export default withEmbeddedContext;
